import {
  apiPost,
  defaultErrorCallback,
  ErrorCallback,
  SuccessCallback,
} from "api/api";
import { SecurePayload } from "entities";
import {
  BookingOnLoadReqConfig,
  BookingOnLoadRes,
  CancelBookingReqConfig,
  CancelBookingRes,
  CreateBookingReqConfig,
  CreateBookingRes,
  EditBookingOnLoadRes,
  EditBookingReqConfig,
  EditBookingRes,
  GetAvailableTimeSlotsByCareProvidersReqConfig,
  GetAvailableTimeSlotsDetailByCareProvidersReqConfig,
  GetAvailableTimeSlotsDetailByCareProvidersRes,
  GetAvailableTimeSlotsDetailReqConfig,
  GetAvailableTimeSlotsDetailRes,
  GetAvailableTimeSlotsReqConfig,
  GetAvailableTimeSlotsRes,
  RequestOtpReqConfig,
  RequestOtpRes,
  RequestSecSessionReqConfig,
  RequestSecSessionRes,
  SearchBookingReqConfig,
  SearchBookingRes,
  VerifyInternalUserReqConfig,
  VerifyInternalUserRes,
  VerifyOtpReqConfig,
  VerifyOtpRes,
} from "entities/Form";
import i18n from "i18next";
import { getApiLangParam } from "utils/helper";

const apiPostWithLang = <Req, Res>(
  endpoint: string,
  config: Req,
  onSuccess: SuccessCallback<Res>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPost(
    endpoint,
    { lang: getApiLangParam(i18n.language), ...config },
    onSuccess,
    onError,
    finallyCallback
  );

export const bookingOnLoad = (
  config: BookingOnLoadReqConfig,
  onSuccess: SuccessCallback<BookingOnLoadRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPostWithLang(
    "/bookingOnLoad",
    config,
    onSuccess,
    onError,
    finallyCallback
  );

export const getAvailableTimeSlots = (
  config: GetAvailableTimeSlotsReqConfig,
  onSuccess: SuccessCallback<GetAvailableTimeSlotsRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPost(
    "/getAvailableTimeSlots",
    config,
    onSuccess,
    onError,
    finallyCallback
  );

export const getAvailableTimeSlotsByCareProviders = (
  config: GetAvailableTimeSlotsByCareProvidersReqConfig,
  onSuccess: SuccessCallback<GetAvailableTimeSlotsRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPost(
    "/getAvailableTimeSlotsByCareProviders",
    config,
    onSuccess,
    onError,
    finallyCallback
  );

export const getAvailableTimeSlotsDetail = (
  config: GetAvailableTimeSlotsDetailReqConfig,
  onSuccess: SuccessCallback<GetAvailableTimeSlotsDetailRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPost(
    "/getAvailableTimeSlotsDetail",
    config,
    onSuccess,
    onError,
    finallyCallback
  );

export const getAvailableTimeSlotsDetailByCareProviders = (
  config: GetAvailableTimeSlotsDetailByCareProvidersReqConfig,
  onSuccess: SuccessCallback<GetAvailableTimeSlotsDetailByCareProvidersRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPost(
    "/getAvailableTimeSlotsDetailByCareProviders",
    config,
    onSuccess,
    onError,
    finallyCallback
  );

export const createBooking = (
  config: CreateBookingReqConfig,
  onSuccess: SuccessCallback<CreateBookingRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPostWithLang(
    "/createBooking",
    config,
    onSuccess,
    onError,
    finallyCallback
  );

export const requestOtp = (
  config: RequestOtpReqConfig,
  onSuccess: SuccessCallback<RequestOtpRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPostWithLang("/requestOtp", config, onSuccess, onError, finallyCallback);

export const verifyOtp = (
  config: VerifyOtpReqConfig,
  onSuccess: SuccessCallback<VerifyOtpRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/verifyOtp", config, onSuccess, onError, finallyCallback);

export const verifyInternalUser = (
  config: VerifyInternalUserReqConfig,
  onSuccess: SuccessCallback<VerifyInternalUserRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/VerifyInternalUser", config, onSuccess, onError, finallyCallback);

export const requestSecSession = (
  config: RequestSecSessionReqConfig,
  onSuccess: SuccessCallback<RequestSecSessionRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/requestSecSession", config, onSuccess, onError, finallyCallback);

export const createBookingEnc = (
  config: SecurePayload,
  onSuccess: SuccessCallback<CreateBookingRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/createBookingEnc", config, onSuccess, onError, finallyCallback);

export const requestOtpEnc = (
  config: SecurePayload,
  onSuccess: SuccessCallback<RequestOtpRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/requestOtpEnc", config, onSuccess, onError, finallyCallback);

export const verifyOtpEnc = (
  config: SecurePayload,
  onSuccess: SuccessCallback<VerifyOtpRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/verifyOtpEnc", config, onSuccess, onError, finallyCallback);

export const searchBooking = (
  config: SearchBookingReqConfig,
  onSuccess: SuccessCallback<SearchBookingRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPostWithLang(
    "/searchBooking",
    config,
    onSuccess,
    onError,
    finallyCallback
  );

export const searchBookingEnc = (
  config: SecurePayload,
  onSuccess: SuccessCallback<SearchBookingRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/searchBookingEnc", config, onSuccess, onError, finallyCallback);

export const editBookingOnLoad = (
  config: {},
  onSuccess: SuccessCallback<EditBookingOnLoadRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/editBookingOnload", config, onSuccess, onError, finallyCallback);

export const editBooking = (
  config: EditBookingReqConfig,
  onSuccess: SuccessCallback<EditBookingRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPostWithLang("/editBooking", config, onSuccess, onError, finallyCallback);

export const editBookingEnc = (
  config: SecurePayload,
  onSuccess: SuccessCallback<EditBookingRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/editBookingEnc", config, onSuccess, onError, finallyCallback);

export const cancelBooking = (
  config: CancelBookingReqConfig,
  onSuccess: SuccessCallback<CancelBookingRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) =>
  apiPostWithLang(
    "/cancelBooking",
    config,
    onSuccess,
    onError,
    finallyCallback
  );

export const cancelBookingEnc = (
  config: SecurePayload,
  onSuccess: SuccessCallback<CancelBookingRes>,
  onError: ErrorCallback = defaultErrorCallback,
  finallyCallback?: () => void
) => apiPost("/cancelBookingEnc", config, onSuccess, onError, finallyCallback);
